(function () {
  if (window.productCardVariantsInitialized) return;
  window.productCardVariantsInitialized = true;

  function updateProductCard(card, input) {
    if (!card || !input) return;

    var variantIdInput = card.querySelector('[data-product-card-variant-id]');
    var addButton = card.querySelector('[data-product-card-add-button]');
    var submitText = card.querySelector('[data-product-card-submit-text]');
    var pricing = card.querySelector('[data-product-card-pricing]');
    var price = card.querySelector('[data-product-card-price-value]');
    var comparePrice = card.querySelector('[data-product-card-compare-price]');
    var comparePriceContainer = comparePrice && comparePrice.closest('.product-card__compare-price');
    var installments = card.querySelector('[data-product-card-installments]');
    var discountBadges = card.querySelectorAll('[data-product-card-discount]');
    var links = card.querySelectorAll('[data-product-card-link]');
    var available = input.dataset.variantAvailable === 'true';
    var hasComparePrice = input.dataset.hasComparePrice === 'true';
    var discountPercentage = Number(input.dataset.discountPercentage || 0);

    if (pricing) {
      pricing.classList.toggle('product-card__pricing--unavailable', !available);
      pricing.setAttribute('aria-hidden', String(!available));
    }

    if (variantIdInput) {
      variantIdInput.value = input.dataset.variantId || '';
      variantIdInput.disabled = !available;
    }

    if (addButton) {
      addButton.disabled = !available;
    }

    if (submitText) {
      submitText.textContent = available
        ? card.dataset.addLabel
        : card.dataset.soldOutLabel;
    }

    if (price && input.dataset.priceFormatted) {
      price.textContent = input.dataset.priceFormatted;
    }

    if (comparePrice) {
      comparePrice.textContent = input.dataset.compareFormatted || '';
      if (comparePriceContainer) {
        comparePriceContainer.classList.toggle('hidden', !hasComparePrice);
      }
    }

    if (installments && input.dataset.installmentFormatted) {
      installments.textContent = installments.dataset.installmentTemplate
        ? installments.dataset.installmentTemplate.replace('__PRICE__', input.dataset.installmentFormatted)
        : installments.textContent;
    }

    discountBadges.forEach(function (badge) {
      badge.textContent = (card.dataset.discountLabel || '-__PERCENT__% OFF')
        .replace('__PERCENT__', discountPercentage);
      badge.classList.toggle('hidden', !available || !discountPercentage);
    });

    links.forEach(function (link) {
      if (input.dataset.variantUrl) {
        link.href = input.dataset.variantUrl;
      }
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-product-card-variant]');
    if (!input) return;

    updateProductCard(input.closest('[data-product-card]'), input);
  });
})();
